<ng-container *ngIf="desktop$ | async">
  <div style="overflow-x: auto;">
    <div class="container-fluid info-list data-table-cont height-unset" [style.minWidth]="minWidth">
      <div class="row table-header">
        <div class="col-lg-12" *ngIf="reportTitle">
          <h3 class="table-title">{{reportTitle}}</h3>
        </div>
        <div class="text-uppercase col-header {{header.class}}" [ngClass]="{sorted: currentSort === header.key}"
          *ngFor="let header of headers" [attr.data-key]="header.key">
          <button (click)="sort(header.key)" class="btn btn-link p-0">
            <app-tooltip-cont [key]="header.tooltipkey" [label]="header.text"></app-tooltip-cont>
            <i class="fa" [ngClass]="{'fa-sort': currentSort != header.key,
                                'fa-sort-up': currentSort === header.key && asc,
                                'fa-sort-down': currentSort === header.key && !asc}"></i>
          </button>
        </div>
      </div>
      <ng-container *ngIf="data">
        <ng-container *ngFor="let item of data | show:showMoreArg; let i = index; ">
          <app-data-table-row [id]="id" [index]="i" [showAll]="showAll" [headers]="headers" [subHeaders]="subHeaders"
            [item]="item" [maxValueMapping]="maxValueMapping" (goTo)="goTo($event.key, $event.value)">
          </app-data-table-row>
          <div *ngIf="item?.subDataTables?.length > 0 && subHeaders?.length > 0" class="collapse item-collapse"
            [attr.id]="'collapse'+id+i">
            <div class="card card-block border-0 py-0 pr-0">
              <div *ngIf="item?.subDataTables?.length > 0" class="accordion" [attr.id]="'accordion'+id+i" role="tablist"
                aria-multiselectable="true">

                <div *ngFor="let subDataTable of item?.subDataTables"
                  class="card border-0 rounded-0 {{subDataTable?.addClass}}">
                  <div class="card-header" role="tab" [attr.id]="'heading'+subDataTable.key+id+i">
                    <h5 class="mb-0">
                      <a data-toggle="collapse" [attr.data-parent]="'#accordion'+id+i"
                        [attr.href]="'#collapse'+subDataTable.key+id+i" aria-expanded="true"
                        [attr.aria-controls]="'collapse'+subDataTable.key+id+i">
                        <i class="fa fa-chevron-up"></i><i class="fa fa-chevron-down"></i>
                        <div class="d-inline-block heading-text">{{subDataTable.text}}</div>

                        <div class=" d-inline-flex">
                          <div class="progress-bar-cont d-inline-block" enAnonLock>
                            <div class="progress" [style.width]="subDataTable.percentValue | perc:'1.2-2'">
                              {{subDataTable.percentValue | perc:'1.2-2'}}
                            </div>
                          </div>
                        </div>
                      </a>
                    </h5>
                  </div>
                  <div [attr.id]="'collapse'+subDataTable.key+id+i" class="collapse show" role="tabpanel"
                    [attr.aria-labelledby]="'heading'+subDataTable.key+id+i">
                    <div class="card-block">
                      <div class="row table-header">
                        <div class="text-uppercase col-header {{header.class}}"
                          [ngClass]="{sorted: currentSort === header.key}" *ngFor="let header of subHeaders"
                          [attr.data-key]="header.key">
                          <button (click)="sort(header.key)" class="btn btn-link p-0">
                            <app-tooltip-cont [key]="header.tooltipkey" [label]="header.text"></app-tooltip-cont>
                            <i class="fa" [ngClass]="{'fa-sort': currentSort != header.key,
                        'fa-sort-up': currentSort === header.key && asc,
                        'fa-sort-down': currentSort === header.key && !asc}"></i>
                          </button>
                        </div>
                      </div>
                      <div *ngFor="let subItem of subDataTable.data" class="row row-body">
                        <div *ngFor="let header of subHeaders" class="{{header.class}} {{header?.format}}"
                          [attr.data-key]="header.key">
                          <ng-container *ngIf="subItem[header.key+'Template'] || !header?.format">
                            <a *ngIf="subItem[header.key+'HREF']" class="item"
                              (click)="goTo(header.key, subItem[header.key])" target="_blank">
                              <ng-container *ngTemplateOutlet="subItemField"></ng-container>
                            </a>

                            <a *ngIf="subItem[header.key+'RouterLink']" class="item"
                              [routerLink]="subItem[header.key+'RouterLink']"
                              [queryParams]="subItem[header.key+'QueryParams']">
                              <ng-container *ngTemplateOutlet="subItemField"></ng-container>
                            </a>

                            <span *ngIf="!subItem[header.key+'HREF'] && !subItem[header.key+'RouterLink']">
                              <ng-container *ngTemplateOutlet="subItemField"></ng-container>
                            </span>
                          </ng-container>

                          <div *ngIf="header?.format === 'percent'" class=""
                            [ngClass]="{'d-flex' : header?.isCollapse !== 'true', 'd-inline-flex' : header?.isCollapse === 'true'}"
                            enAnonLock>
                            {{subItem[header.key] | perc:'1.2-2'}}
                          </div>

                          <div *ngIf="header?.format === 'percentbar'" class=""
                            [ngClass]="{'d-flex' : header?.isCollapse !== 'true', 'd-inline-flex' : header?.isCollapse === 'true'}"
                            enAnonLock>
                            <div class="value mr-2">{{item[header.key] | perc:'1.2-2'}}</div>
                            <div class="progress-bar-cont d-inline-block"
                              *ngIf="maxValueMapping && maxValueMapping[header.key]">
                              <div class="progress"
                                [style.width]="((subItem[header.key] / maxValueMapping[header.key] ) * 100) + '%'">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </ng-container>


        <ng-container *ngFor="let item of data; let i = index;">
          <div *ngIf="showAll" class="row row-body">
            <div class="{{header.class}}" *ngFor="let header of headers" [attr.data-key]="header.key">

              <a *ngIf="item[header.key+'HREF']" class="item" (click)="goTo(header.key, item[header.key])"
                target="_blank">
                <ng-container *ngTemplateOutlet="itemField"></ng-container>
              </a>

              <a *ngIf="item[header.key+'RouterLink']" class="item" [routerLink]="item[header.key+'RouterLink']">
                <ng-container *ngTemplateOutlet="itemField"></ng-container>
              </a>

              <span *ngIf="!item[header.key+'HREF'] && !item[header.key+'RouterLink']">
                <ng-container *ngTemplateOutlet="itemField"></ng-container>
              </span>

            </div>
          </div>
        </ng-container>
      </ng-container>

    </div>
  </div>
  <div [hidden]="showAll" class="row row-body show-more" *ngIf="data?.length > limit">
    <div class="col-lg-12">
      <button type="button" class="btn btn-primary btn-sm btn-block show-more" (click)="toggleShowMore()">
        <ng-container *ngIf="isFreemium">
          <div class="value text-capitalize d-inline-block mr-3">
            <div class="freemium-lock">
              <i class="fa fa-lock"></i>
            </div>
          </div>
        </ng-container> {{(showMore)?"Hide":"Show More"}}
      </button>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="tablet$ | async">

  <div class="d-flex" *ngIf="headers?.length > 0">
    <div class="d-inline-block" style="min-width: 100px; max-width: 50%; overflow: hidden;">
      <ng-container [ngTemplateOutlet]="mobileheader" [ngTemplateOutletContext]="{ header: headers[0] }"></ng-container>
    </div>

    <div class="d-inline-block" style="flex: 1 0; overflow: hidden">
      <swiper #swiper [slidesPerView]="(portrait$ | async) ? 1.5 : (mobile$ | async) ? 3 : 4" [spaceBetween]="0"
        scrollbar=".swiper-scrollbar">
        <ng-template swiperSlide *ngFor="let header of headers | slice:1; let j = index;">
          <ng-container [ngTemplateOutlet]="mobileheader" [ngTemplateOutletContext]="{ header: header }"></ng-container>
        </ng-template>
      </swiper>
      <div class="swiper-scrollbar js-swiper-scrollbar"></div>
    </div>
  </div>

  <div [hidden]="showAll" class="row row-body show-more" *ngIf="data?.length > limit">
    <div class="col-lg-12">
      <button type="button" class="btn btn-primary btn-sm btn-block show-more" (click)="toggleShowMore()">
        <ng-container *ngIf="isFreemium">
          <div class="value text-capitalize d-inline-block mr-3">
            <div class="freemium-lock">
              <i class="fa fa-lock"></i>
            </div>
          </div>
        </ng-container> {{(showMore)?"Hide":"Show More"}}
      </button>
    </div>
  </div>
</ng-container>

<ng-template #mobileheader let-header="header">
  <ng-container *ngIf="header">
    <div class="text-uppercase col-header" [ngClass]="{sorted: currentSort === header?.key}"
      [attr.data-key]="header?.key">
      <button (click)="sort(header?.key)" class="btn btn-link py-0 pl-0 pr-2">
        <app-tooltip-cont [key]="header?.tooltipkey" [label]="header?.text"></app-tooltip-cont>
        <i class="fa ml-2" [ngClass]="{'fa-sort': currentSort != header.key,
                                'fa-sort-up': currentSort === header.key && asc,
                                'fa-sort-down': currentSort === header.key && !asc}"></i>
      </button>
    </div>
    <div class="row row-body row-item height-100 align-items-center"
      *ngFor="let item of data | show:showMoreArg; let i = index; ">
      <div class="{{header?.format}} overflow-hidden white-space-nowrap text-overflow-ellipsis">
        <ng-container *ngIf="( header?.lockedInFreemium && isFreemium ) || header?.lock?.call()">
          <div class='freemium-lock'>
            <i class='fa fa-lock'></i>
          </div>
        </ng-container>
        <ng-container *ngIf="( !header?.lockedInFreemium || !isFreemium ) && !header?.lock?.call()">
          <ng-container *ngIf="item[header.key+'Template'] || (!item[header.key+'Template'] && !header?.format)">
            <ng-container *ngIf="item[header.key+'HREF']">
              <a class="item" (click)="goToClick(header.key, item[header.key])" target="_blank">
                <ng-container *ngIf='item[header.key + "Template"] != null'>
                  <ng-container
                    *ngTemplateOutlet='item[header.key + "Template"]; context: { row: item, item: item[header.key]}'>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf='item[header.key + "Template"] == null'>
                  <span enAnonLock>{{ item[header.key] }}</span>
                </ng-container>
              </a>
            </ng-container>

            <ng-container *ngIf="item[header.key+'RouterLink']">
              <a class="item" [routerLink]="item[header.key+'RouterLink']"
                [queryParams]="item[header.key+'QueryParams']">

                <ng-container *ngIf='item[header.key + "Template"] != null'>
                  <ng-container
                    *ngTemplateOutlet='item[header.key + "Template"]; context: { row: item, item: item[header.key]}'>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf='item[header.key + "Template"] == null'>
                  <span>{{ item[header.key] }}</span>
                </ng-container>
              </a>
            </ng-container>

            <ng-container *ngIf="!item[header.key+'HREF'] && !item[header.key+'RouterLink']">
              <span>
                <ng-container *ngIf='item[header.key + "Template"] != null'>
                  <ng-container
                    *ngTemplateOutlet='item[header.key + "Template"]; context: { row: item, item: item[header.key]}'>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf='item[header.key + "Template"] == null'>
                  <span>{{ item[header.key] }}</span>
                </ng-container>
              </span>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="!item[header.key + 'Template'] && header?.format">
            <ng-container *ngIf="header?.format === 'percent'">
              <div class=" d-inline-flex" enAnonLock>
                {{item[header.key] | perc:'1.2-2'}}
              </div>
            </ng-container>
            <ng-container *ngIf="header?.format === 'percentRating'">
              <div class=" d-inline-flex" enAnonLock>
                <risk-heat-meter [risk]='item[header.key + "Rating"]'></risk-heat-meter>
              </div>
            </ng-container>
            <ng-container *ngIf="header?.format === 'percentbar'">
              <div class="main-cont d-inline-flex" enAnonLock>
                <div class="progress-bar-cont d-inline-block" *ngIf="maxValueMapping && maxValueMapping[header.key]">
                  <div class="progress" [style.width]="((item[header.key] / maxValueMapping[header.key] ) * 100) + '%'">
                    {{item[header.key] | perc:'1.2-2'}}
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-container
          *ngIf="header?.isCollapse === 'true' && subHeaders?.length > 0 && item?.subDataTables?.length > 0">
          <a class="btn btn-link" data-toggle="collapse" [attr.href]="'#collapse'+header?.key+i" aria-expanded="false"
            [attr.aria-controls]="'collapse'+id+i">
            <i class="fa fa-chevron-down"></i>
            <i class="fa fa-chevron-up"></i>
          </a>
        </ng-container>
      </div>

    </div>
  </ng-container>
</ng-template>

<ng-template #itemField>
  <ng-container *ngIf='item[header.key + "Template"] != null'>
    <ng-container *ngTemplateOutlet='item[header.key + "Template"]; context: { row: item, item: item[header.key]}'>
    </ng-container>
  </ng-container>
  <ng-container *ngIf='item[header.key + "Template"] == null'>
    <span>{{ item[header.key] }}</span>
  </ng-container>
</ng-template>

<ng-template #subItemField>
  <ng-container *ngIf='subItem[header.key + "Template"] != null'>
    <ng-container
      *ngTemplateOutlet='subItem[header.key + "Template"]; context: { row: subItem, item: subItem[header.key]}'>
    </ng-container>
  </ng-container>
  <ng-container *ngIf='subItem[header.key + "Template"] == null'>
    <span>{{ subItem[header.key] }}</span>
  </ng-container>
</ng-template>